import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';
import { SAMPLE_EVENTS_QUERY } from 'api/sample-events/sample-events-query-builder';
import { ALL_SAMPLE_EVENT_NAMES_QUERY } from 'api/sample-events/useQuerySampleEventNames';

import {
  mutation as removeSampleEventMutation,
  buildVariables as buildRemoveSampleEventVariables,
} from './remove-sample-event-mutation-builder';

export default function useRemoveSampleEvent(options = {}) {
  const [executeMutation, response] = useMutation(removeSampleEventMutation, {
    successMsg: 'Sample event deleted',
    refetchQueries: [SAMPLE_EVENTS_QUERY, ALL_SAMPLE_EVENT_NAMES_QUERY],
    ...options,
    context: { permission: permissions.writeSampleEvents },
  });

  const removeSampleEvent = async ({ id }) => {
    const mutationResponse = await executeMutation({
      variables: {
        ...buildRemoveSampleEventVariables({ id }),
      },
    });

    return mutationResponse;
  };

  return [removeSampleEvent, response];
}
